/**
 * 首页项目服务
 */

import { Row, Col } from 'antd';

import {
    DeploymentUnitOutlined,
    CustomerServiceOutlined,
    AimOutlined,
    DatabaseOutlined,
} from '@ant-design/icons';


const Project = () => {
    return <>
        <Row>
            <Col offset={4} span={4}>
                <div className='project-box'>
                    <div className='box-icon'><DeploymentUnitOutlined /></div>
                    <p>信息系统运维</p>
                </div>
            </Col>
            <Col span={4}>
                <div className='project-box'>
                    <div className='box-icon'><CustomerServiceOutlined /></div>
                    <p>信息技术咨询</p>
                </div>
            </Col>
            <Col span={4}>
                <div className='project-box'>
                    <div className='box-icon'><AimOutlined /></div>
                    <p>信息系统集成</p>
                </div>
            </Col>
            <Col span={4}>
                <div className='project-box'>
                    <div className='box-icon'><DatabaseOutlined /></div>
                    <p>数据中心运维</p>
                </div>
            </Col>
        </Row>
    </>
}

export default Project;